import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';

import PropTypes from 'prop-types';
import { playerType } from 'types/components/player';

import { Container } from './styles';

const Player = ({ url, setFinished, watchClass, idStudent, playing, stopClass }) => {
    const ref = useRef();
    const [isRunning, setIsRunning] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const tenMinutes = 25000;

    const handleFinish = () => {
        setFinished(true);
        stopClass(watchClass.id, 0);
    };

    const onReady = useCallback(() => {
        if (watchClass.class_user.time_stop === 0 || parseInt(ref.current.getDuration()) <= watchClass.class_user.time_stop) {
            ref.current.seekTo(0, 'seconds');
            return;
        }

        const timeToStart = watchClass.class_user.time_stop.toString();
        ref.current.seekTo(timeToStart, 'seconds');
    }, [ref.current, watchClass]);

    const checkStopClass = () => {
        return (
            ref?.current &&
            parseInt(ref.current.getCurrentTime()) !== 0 &&
            ref.current.getCurrentTime() < ref.current.getDuration() &&
            isRunning
        );
    };

    const saveTimeStopLoop = () => {
        setInterval(() => {
            if (!checkStopClass()) {
                setIsSaving(false);
                return;
            }

            stopClass(watchClass.id, parseInt(ref.current.getCurrentTime()));
        }, tenMinutes);
    };

    useEffect(() => {
        if (isSaving || !isRunning) {
            return;
        }

        setIsSaving(true);
        saveTimeStopLoop();
    }, [isRunning]);

    useEffect(() => {
        setIsRunning(false);
    }, [watchClass.id]);

    return (
        <Container>
            <ReactPlayer
                ref={ref}
                url={url}
                width="100%"
                height="100%"
                controls={true}
                className="react-player"
                onPause={() => setIsRunning(false)}
                onPlay={() => setIsRunning(true)}
                onEnded={() => handleFinish()}
                onReady={playing !== undefined ? false : onReady}
                playing={playing !== undefined ? playing : true}
            />
        </Container>
    );
};

Player.propTypes = {
    url: PropTypes.string.isRequired,
    timeStop: PropTypes.number,
    setFinished: PropTypes.func,
    watchClass: PropTypes.shape(playerType).isRequired,
    idStudent: PropTypes.number.isRequired,
    stopClass: PropTypes.func.isRequired
};

export default Player;
